const loadData = function(url, cb)
{
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        success: cb
    });
}

module.exports = (function($)
{
    $.fn.selectize = function()
    {
        const selectize = {
            util: {},
            dropdown: {}
        };
        let $openedList = null;
        let counter = 0;

        selectize.util.findParentOverflowHidden = function($el)
        {
            let $parent = null;

            $el.parents().each(function()
            {
                if($(this).css('overflow') == 'hidden')
                {
                    $parent = $(this);
                    return false;
                }
            });

            return $parent;
        };

        selectize.util.generateCustomList = function($select, $list)
        {
            let htmlFragment = [], $options;

            $options = $select.children('option');

            if($options.length) {

                $list.empty();

                $options.each(function(index) {
                    let htmlFragment = '';

                    //if ( index > 0 || $(this).attr('value') ) {
                    const label = $(this).text().trim();
                    if(label && $(this).val() !== '__placeholder__')
                    {
                        htmlFragment = `
                            <li class="selectize__list__item">
                                <span>
                                    ${label}
                                </span>
                            </li>`;

                        $(htmlFragment).data('option', $(this)).appendTo($list);
                    }
                });

                $list.find('li:last').addClass('last');
            }
        };

        selectize.util.setValue = function($select, $value) {
            let $selected = $select.children(':selected');
            let isPlaceholder = false;
            let label = '';

            if ($selected.length < 1)
            {
                $selected = $select.children().first();
            }

            if ($selected.length)
            {
                label = $selected.text().trim();
                if($selected.val() === '__placeholder__')
                {
                    label = `
                        <span class="selectize__placeholder">
                            ${label}
                        </span>`;

                    isPlaceholder = true;
                }
            }
            // если внутри реального селекта нет опшенов
            else
            {
                const placeholder = $select.attr('placeholder');
                if(placeholder)
                {
                    label = `
                        <span class="selectize__placeholder">
                            ${placeholder}
                        </span>`;

                    isPlaceholder = true;
                }
            }

            $value.html(label);
            $value.closest('.selectize')[isPlaceholder ? 'removeClass' : 'addClass']('_selected');
        };

        return this.each(function() {
            var $select = $(this), selectizeOpts = null;

            if($select.data('selectize_is_init') === true) {
                return;
            }

            var $html = $(`
                <div class="selectize">
                    <div class="selectize__value">
                        <div></div>
                        <svg class="selectize__bullet-top">
                            <use xlink:href="#select_arrow" x="0" y="0" />
                        </svg>
                        <svg class="selectize__bullet-bottom">
                            <use xlink:href="#select_arrow" x="0" y="0" />
                        </svg>
                    </div>
                    <div class="selectize__dropdown">
                        <div class="selectize__dropdown-wrapper">
                            <ul class="selectize__list"></ul>
                        </div>
                    </div>
                </div>
            `);

            //const $bgbody = $html.find('.uis-body');
            const $dropdown = $html.find('.selectize__dropdown');
            const $dropdownWrapper = $html.find('.selectize__dropdown-wrapper');
            const $list = $html.find('.selectize__list');
            const $valueBtn = $html.find('.selectize__value');
            const $value = $valueBtn.children('div');
            const $bar = $html.find('.uis-bar');
            const $slider = $bar.find('.uis-slider');

            let isScrolling = false;
            let info = {};
            let isOpen = false;
            let maxHeight = parseInt($select.attr('data-max-height')) || 300;
            let changeEvent = $select.attr('data-change-event');

            if($select.data('theme'))
            {
                $html.addClass(`selectize-${$select.data('theme')}`);
            }

            const dropdownDetectTopPos = function()
            {
                var posTop, listH, parentH, widgetH, listOffset, parentOffset, $parent;

                posTop = 0;
                $parent = selectize.util.findParentOverflowHidden($html);

                if($parent) {
                    parentH = $parent.innerHeight();
                    listH = $dropdown.innerHeight();
                    widgetH = $html.innerHeight();

                    parentOffset = $parent.offset();
                    listOffset = $dropdown.offset();

                    if((parentH+parentOffset.top) < (listH+listOffset.top)) {
                        if(parentOffset.top < (listOffset.top-listH-widgetH)) {
                            posTop = (listH-widgetH)*-1;
                        }
                    }
                }

                $dropdown.css({ top : $html.height() });
            };

            const openList = function()
            {
                $html.addClass('_opened');

                setTimeout(function() {
                    $(document.body).on('click.selectize', closeList);
                }, 50);

                info.scrollHeight = $list.get(0).scrollHeight;
                info.viewPortHeight = $list.height();
                info.scrollDiff = info.scrollHeight - info.viewPortHeight;
                info.scrollBarHeight = $bar.height();
                info.sliderHeight = $slider.height() + 2;
                info.scrollBarDiff = info.scrollBarHeight - info.sliderHeight;
                $slider.css('top', 0);
                info.sliderTop = 0;
                $list.get(0).scrollTop = 0; // refresh for FF
                if ( info.scrollDiff < 1 ) {
                    $html.addClass('_nobar');
                    $dropdown.height(Math.min($list.height(), maxHeight));
                    //$bgbody.height($list.height() + 28);
                }
                else {
                    $html.removeClass('_nobar');
                }

                if(!isOpen) {
                    if(maxHeight > 0 && $list.height() > maxHeight) {
                        $dropdownWrapper.css({overflow: 'hidden', height: maxHeight});
                        $dropdownWrapper.jScrollPane({verticalArrowPositions: 'split'});
                    }
                    isOpen = true;
                }

                dropdownDetectTopPos();

                $openedList = $dropdown;
            };

            const closeList = function()
            {
                if (isScrolling) return;

                $html.removeClass('_opened');
                $dropdown.css({top: 0});
                if (info.scrollDiff < 1)
                {
                    $dropdown.height(0);
                    //$bgbody.height(25);
                }
                $(document.body).off('click.selectize');
            };

            selectizeOpts = $select.data('selectize');

            if(selectizeOpts && Object.prototype.toString.call(selectizeOpts) == '[object Object]' && selectizeOpts.hasOwnProperty('selectWidth')) {
                $html.css('width', selectizeOpts.selectWidth);
            }

            // create list
            if($select.attr('placeholder'))
            {
                $value.text($select.attr('placeholder'));
            }

            const dataUrl = $select.data('url');
            if(dataUrl)
            {
                loadData(dataUrl, function(response)
                {
                    var htmlFragment = [], i, len;

                    if(response && response.data !== undefined)
                    {
                        for(key in response.data)
                        {
                            htmlFragment.push('<option');
                            htmlFragment.push(' value="');
                            htmlFragment.push(key);
                            htmlFragment.push('">');
                            htmlFragment.push(response.data[key]);
                            htmlFragment.push('</option>');
                        }

                        $select.append( htmlFragment.join('') );
                        selectize.util.generateCustomList($select, $list);
                        selectize.util.setValue($select, $value);
                    }
                });
            }
            else
            {
                selectize.util.generateCustomList($select, $list);
                selectize.util.setValue($select, $value);
            }

            // bind onclick
            $list.on('click', 'li', function()
            {
                const $option = $(this).data('option');

                $value.text($option.text());

                if (/^http/i.test($option.val()))
                {
                    window.open($option.val());
                }
                else
                {
                    $select.children('option:selected').removeAttr('selected');
                    $option.prop('selected','selected');
                    $select.trigger('change', { option: $option });
                    //$(this).data('option').trigger('click');
                }
            });

            $valueBtn.click(function(e) {
                if (!$html.hasClass('_opened') && !$select.attr('disabled'))
                {
                    openList();
                    //return false;
                }
            });

            $select.hide();

            if($select.attr('disabled'))
            {
                $html.addClass('_disabled')
            }

            // подписываемся на изменение атрибутов у селекта
            if(window.MutationObserver) {
                const observer = new MutationObserver(function(records)
                {
                    const recordTypes = [];

                    records.forEach(record => {
                        if(recordTypes.indexOf(record.type) === -1) {
                            recordTypes.push(record.type);
                        }
                    });

                    if(recordTypes.indexOf('childList') >= 0) {
                        selectize.util.generateCustomList($select, $list);
                        selectize.util.setValue($select, $value);
                    }

                    if($select.attr('disabled'))
                    {
                        if(!$html.hasClass('_disabled'))
                        {
                            $html.addClass('_disabled');
                            closeList();
                        }
                    }
                    else
                    {
                        $html.removeClass('_disabled');
                    }
                });

                observer.observe($select.get(0), { attributes: true, childList: true });
            }

            $select.on('change', function (e) {
                if (changeEvent) {
                    $(document).trigger(changeEvent, [$select.val(), e.target]);
                }
            });

            $select.change(function()
            {
                selectize.util.generateCustomList($select, $list);
                selectize.util.setValue($select, $value);

                if(maxHeight > 0 && $list.height() > maxHeight) {
                    var jsp = $dropdownWrapper.data('jsp');
                    if(jsp) {
                        jsp.reinitialise();
                    }
                    else {
                        $dropdownWrapper.css({overflow: 'hidden', height: maxHeight});
                        $dropdownWrapper.jScrollPane({verticalArrowPositions: 'split'});
                    }
                }
            });

            $html.insertAfter($select);
            $select.data('selectize_is_init', true);

            $select.closest('form').on('reset', function() {
                setTimeout(function() {
                    selectize.util.generateCustomList($select, $list);
                    selectize.util.setValue($select, $value);
                }, 50);
            });
        });
    }


    // $(window).bind('hashchange', function() {
    //     var hash = location.hash;
    // });
})(require('jquery'));
